import React from 'react';

import { Box } from '@hz-design-system/web-ui';
import { ListingAttribute } from '@/client/components/ListingsNew/components';
import formatAttributeBasedOnKey from '@/client/utils/formatters/formatBasedOnKey';

import Classes from './ListingExtendedAttributes.module.scss';
import { Attribute } from '@/client/types/Listings';

const SPACE_SEPARATOR = ' ';

interface ListingExtendedAttributesProps {
  extendedAttributes?: Attribute[];
}

const ListingExtendedAttributes: React.FC<ListingExtendedAttributesProps> = ({ extendedAttributes }) => {
  return (
    <Box as="div" name="Listing-extended-attributes-mweb" className={Classes['hz-Listing-extended-attributes-mweb']}>
      {extendedAttributes?.map((attribute) => (
        <ListingAttribute key={attribute.key} type="extended">
          {formatAttributeBasedOnKey(attribute.key, attribute.value, undefined, undefined)}
          {SPACE_SEPARATOR}
          {attribute.unit && attribute.unit}
        </ListingAttribute>
      ))}
    </Box>
  );
};

export default ListingExtendedAttributes;
